export const guestListData = {
  seo: {
    title: 'Wedding Guest List Manager | Free Guest List with RSVP | Joy',
    content: 'Easily create or import your wedding guest list and collect RSVPs, assign plus ones and labels, send messages, and more.',
  },
  hero: {
    title: 'Your guest list deserves an upgrade.',
  },

  moreTimeTogetherText: 'Less time guest listing, more time bucket listing.',
  allInvitesText: 'Send and track it all.',
  transcendText: 'From Save the Dates to RSVP reminders, talk to your guests from one place.',
  speechBubbles: {
    eyebrow: 'Announcements & Reminders',
    title: 'Easily message anyone or everyone.',
    content: 'Whether an RSVP reminder or a last-minute announcement, send updates right to your guests’ inboxes.',
  },

  tracking: {
    eyebrow: 'Email and Invite Tracking',
    title: 'See who’s seen what.',
    content: 'Gone are the days of ghosting. Know who has opened, read, and replied to your messages.',
  },

  focusText: 'Designed to let you focus on what matters.',

  connectedGuestList: {
    eyebrow: '',
    title: 'The connected wedding guest list.',
    content: `Organize all the details of your wedding day. Collect addresses, add or import guest lists, send messages, and track RSVPs, all from your guest list.`,
    button: 'Get Started',

    organize: {
      title: 'Easily organize your guests any way you want.',
      content: 'Use guest tags, assign plus ones, and group guests into households to create a planning paradise.',
      learnMore: 'Learn more',
      altText: 'easily organize your guest list',
    },

    send: {
      title: 'Communicate with guests directly from your guest list.',
      content: 'Send Save the Dates, invites, messages, and even reminders to your guests.',
      learnMore: 'Learn more',
      altText: 'our guestlist is helpful',
    },

    track: {
      title: 'Track RSVPs, meal choices, and a whole lot more.',
      content:
        'See who’s attending each event and who hasn’t yet opened your invite. Ask guests anything, from meal choice to travel plans.',
      learnMore: 'Learn more',
      altText: 'easily track guests',
    },
  },

  editing: {
    edit: {
      altText: 'easily add guests',
      eyebrow: 'Multiple Editors',
      title: 'Work on your guest list together without sharing passwords.',
      content:
        'Invite your partner, mom, or wedding planner to collaborate on your guest list without having to share accounts or passwords.',
    },
    import: {
      eyebrow: 'Spreadsheet Import and Export',
      title: 'Already started your list? All good.',
      content: 'Import your spreadsheet to create your smarter guest list, then export it to share with vendors.',
      altText: 'import excel guest list',
    },
  },

  tags: {
    family: 'Family',
    maidOfHonor: 'Maid of Honor',
    bestWoman: 'Best Woman',
    weddigParty: 'Wedding Party',
    collegeFriends: 'College Friends',
    eyebrow: 'Smart Guest Tags',
    title: 'Organizing is your super power.',
    content: `Whether for your wedding party, family members, or table arrangement, use tags to simplify your wedding planning.`,
  },

  feature: {
    invites: {
      altText: 'plan your rehearsal dinner',
      title: 'Easily manage private schedules, invites, and RSVPs for your guests.',
      content: 'Apply tags to invitations, RSVP questions, and events to manage who sees what.',
    },
    prioritize: {
      title: 'Prioritize guests from A to B-List, even C.',
      content: `Track groups of guests and send out invitations in batches. `,
      altText: 'soft guest list with tags',
    },
    sort: {
      altText: 'sort your guest list with out filter feature',
      title: 'Filter and sort to your heart’s desire.',
      content: 'Smart guest tags make it simple to filter responses for group.',
    },
  },

  creativeTags: {
    eyebrow: 'Tag guests <br />any way you want.',
    title: '',
    content: `Couples have used tags in many unique ways to help them plan. Get inspiration from some of our favorites.`,
  },

  organizingGuests: {
    eyebrow: '',
    title: 'Group your guests,<br /> we’ll take care<br />  of the rest.',
    content:
      'Assign plus ones, allow guests to RSVP for their households, and more, with the guest list that keeps all your plans streamlined.',
    altText: 'plus ones feature',
    plusOnes: {
      title: 'Manage Plus Ones',
      content: `Add or limit plus ones so guests can only RSVP for their assigned headcount.`,
    },

    rsvpGroups: {
      title: 'Make RSVP Groups',
      content: 'Allow guests to easily respond on behalf of their household or party.',
    },
  },

  messagingInvitations: {
    eyebrow: 'All the Cards',
    title: 'Signed, sealed, delivered.',
    content: 'Send announcements and invitations that beautifully match your site.',
    imgAlt: 'messaging invitations',
    columns: [
      {
        title: 'Wedding Invitations',
        content: 'Create and send beautiful invites, then watch the responses roll right into your guest list.',
      },
      {
        title: 'Save the Dates',
        content: 'With Save the Dates that match your site, guests can quickly add your date to their digital calendars.',
      },
      {
        title: 'Custom eCards',
        content: 'Customize eCard designs to use for any and all your wedding events, or even as thank you notes.',
      },
    ],
  },

  stopGuestimating: {
    eyebrow: 'Response Tracking',
    title: 'Stop guestimating.',
    content: `Collect details for multiple events, see guests' responses as they come in, and view up-to-date head counts at a glance.`,
    learnMore: 'Learn more about RSVP',
    eventAttendance: 'Event Attendance',
    noteToTheCouple: 'Note to the Couple',
    altText: 'stopGuestimating image',
  },

  celebrateYourLove: {
    title: 'Everyone you love, celebrating your love.',
    weddingTitle: 'The connected wedding guest list.',
    weddingPartTitle: 'A guest list</br >worthy of your celebration.',
  },

  rsvpQuestions: {
    eyebrow: 'RSVP Questions',
    title: 'Because it’s never as simple as “will you be attending?”',
    content: 'Ask as many questions as you’ll need to plan your big day.',
    learnMore: 'Learn More',
    joinUsForLunch: 'Are you interested in joining us for day-after brunch?',
    whereAreYouStaying: 'Where are you staying?',
    willyouAttend: 'Will you be attending?',
    anyAdvice: 'Any advice for newlyweds?',
    anyAllergies: 'Do you have any allergies?',
    needABabySitter: 'Do you need a babysitter?',
  },

  rsvpTracking: {
    eyebrow: 'Real-time Response Tracking',
    title: 'All the numbers, right in your guest list.',
    content: 'Get an accurate headcount of your guests, including plus ones. Track RSVPs, meal choices, and more.',
    outOfTowners: 'Out of towners',
    babies: 'Babies',
    collegeFriends: 'College friends',
    bestFriends: 'Best friends',
    peoplePerTable: 'People per table',
    learnMore: 'Learn More',
  },

  app: {
    eyebrow: 'Guest Mobile App',
    title: 'Start the party before the party',
    content: 'The fun way to collect memories and give your guests the info they need on the go.',
  },

  stats: {
    title: 'We’ve helped millions plan and celebrate around the world.',
    subtitle: 'That’s more cake, flowers and happy tears than we can count.',
  },

  cx: {
    title: 'And remember,<br/>we’re always here for you.',
    content: 'Chat with the best customer service team in weddings —<br/>we’re here to make sure you get to the big day without the fray.',
    quote: 'I get paid to help people in love — it doesn’t get better than that!',
    caption: 'Jane Doe, Team Member since 2015',
  },

  overviewArt: {
    title: 'Everything guest at a glance.',
    oragnize: {
      image: 'guest-list/overview-art/static/organize-v2.jpg',
      title: 'Organize your guests.',
      body: 'Assign plus ones, group families and dates together, and organize guests with tags. ',
    },
    communicate: {
      image: 'guest-list/overview-art/static/commmunicate-v3.jpg',
      title: 'Communicate with your guests.',
      body: 'Send Save the Dates, invites, custom eCards and more, right from your guest list.',
    },
    track: {
      image: 'guest-list/overview-art/static/track-v3.jpg',
      title: 'Track your guests’ responses.',
      body: 'See guests’ RSVPs, who has opened your invite, and who’s purchased a gift from your registry, all in one place.',
    },
  },

  addressCollection: {
    eyebrowNew: 'New',
    eyebrow: 'Address Collection',
    title: 'Easily gather guest addresses.',
    body: 'Jump start your guest list with an address collection tool that’s quick and easy for you and your guests.',
  },

  guestNames: {
    titleFirstWord: 'Guest \u00A0',
    titleSecondWord: 'List',
    title: `Connect all the dots with the Connected Guest List.`,
    subtitle: 'Track every detail, from table numbers and meal choices, to in-laws and work friends.',
    columns: [
      {
        title: 'Names.',
        imageUrl: 'guest-list/guest-list-visual/gl_1.svg',
        imgAlt: 'guest list names',
        width: 128,
      },
      {
        title: 'Tags.',
        imageUrl: 'guest-list/guest-list-visual/gl_2.svg',
        imgAlt: 'guest list tags',
        width: 400,
      },
      {
        title: 'Plus Ones.',
        imageUrl: 'guest-list/guest-list-visual/gl_3.svg',
        imgAlt: 'guest list plus ones',
        width: 40,
      },
      {
        title: 'Emails.',
        imageUrl: 'guest-list/guest-list-visual/gl_4.svg',
        imgAlt: 'guest list emails',
        width: 140,
      },
      {
        title: 'Status.',
        imageUrl: 'guest-list/guest-list-visual/gl_5.svg',
        imgAlt: 'guest list status',
        width: 213,
      },
      {
        title: 'Anything…',
        imageUrl: 'guest-list/guest-list-visual/gl_6.svg',
        imgAlt: 'guest list anything',
        width: 86,
      },
      {
        title: 'and',
        imageUrl: 'guest-list/guest-list-visual/gl_7.svg',
        imgAlt: 'guest list and',
        width: 100,
      },
      {
        title: 'Everything!',
        imageUrl: 'guest-list/guest-list-visual/gl_8.svg',
        imgAlt: 'guest list everything',
        width: 173,
      },
    ],
  },
  rsvpText: 'Still have questions?',

  guestStats: [
    {
      title: 'million',
      body: 'The largest guest list in Joy',
      endingNumber: 8,
      incrementFrequency: 150,
    },
    {
      title: 'countries',
      body: 'Screaming babies have interrupted weddings on',
      endingNumber: 86,
      incrementFrequency: 100,
    },
    {
      title: 'guests',
      body: 'People around the world',
      endingNumber: 768,
      incrementFrequency: 20,
    },
  ],

  tagNames: [
    {
      alt: 'Dog Owners',
      src: 'guest-list/tags-icons/dogowners-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/dogowners.svg',
    },
    {
      alt: 'Abc Lists',
      src: 'guest-list/tags-icons/alist-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/alist.svg',
    },
    {
      alt: 'Out of Towners',
      src: 'guest-list/tags-icons/outoftowners-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/outoftowners.svg',
    },
    {
      alt: 'Table Numbers',
      src: 'guest-list/tags-icons/tablenumbers-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/tablenumbers.svg',
    },
    {
      alt: 'Singles',
      src: 'guest-list/tags-icons/singles-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/singles.svg',
    },
    {
      alt: 'Dog Owners',
      src: 'guest-list/tags-icons/dogowners-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/dogowners.svg',
    },
    {
      alt: 'Abc Lists',
      src: 'guest-list/tags-icons/alist-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/alist.svg',
    },
    {
      alt: 'Designated Drivers',
      src: 'guest-list/tags-icons/designateddrivers-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/designateddrivers.svg',
    },
    {
      alt: 'Kids',
      src: 'guest-list/tags-icons/kids-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/kids.svg',
    },
    {
      alt: 'College Friends',
      src: 'guest-list/tags-icons/collegefriends-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/collegefriends.svg',
    },
    {
      alt: 'Besties',
      src: 'guest-list/tags-icons/besties-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/besties.svg',
    },
    {
      alt: 'Gift tracking',
      src: 'guest-list/tags-icons/gifttracking-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/gifttracking.svg',
    },
    {
      alt: 'Designated Drivers',
      src: 'guest-list/tags-icons/designateddrivers-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/designateddrivers.svg',
    },
    {
      alt: 'Kids',
      src: 'guest-list/tags-icons/kids-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/kids.svg',
    },
    {
      alt: 'Vegans',
      src: 'guest-list/tags-icons/vegans-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/vegans.svg',
    },
    {
      alt: 'Maybes',
      src: 'guest-list/tags-icons/maybes-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/maybes.svg',
    },
    {
      alt: 'Significant Others',
      src: 'guest-list/tags-icons/significantothers-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/significantothers.svg',
    },
    {
      alt: 'Mom’s Friends',
      src: 'guest-list/tags-icons/momsfriends-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/momsfriends.svg',
    },
    {
      alt: 'Allergies',
      src: 'guest-list/tags-icons/allergies-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/allergies.svg',
    },
    {
      alt: 'Vegans',
      src: 'guest-list/tags-icons/vegans-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/vegans.svg',
    },
    {
      alt: 'Maybes',
      src: 'guest-list/tags-icons/maybes-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/maybes.svg',
    },
    {
      alt: 'College Friends',
      src: 'guest-list/tags-icons/collegefriends-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/collegefriends.svg',
    },
    {
      alt: 'Besties',
      src: 'guest-list/tags-icons/besties-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/besties.svg',
    },
    {
      alt: 'Gift tracking',
      src: 'guest-list/tags-icons/gifttracking-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/gifttracking.svg',
    },
    {
      alt: 'Kids',
      src: 'guest-list/tags-icons/kids-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/kids.svg',
    },
    {
      alt: 'Vegans',
      src: 'guest-list/tags-icons/vegans-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/vegans.svg',
    },
    {
      alt: 'Gift tracking',
      src: 'guest-list/tags-icons/gifttracking-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/gifttracking.svg',
    },
    {
      alt: 'College Friends',
      src: 'guest-list/tags-icons/collegefriends-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/collegefriends.svg',
    },
    {
      alt: 'Besties',
      src: 'guest-list/tags-icons/besties-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/besties.svg',
    },
    {
      alt: 'Designated Drivers',
      src: 'guest-list/tags-icons/designateddrivers-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/designateddrivers.svg',
    },
    {
      alt: 'Maybes',
      src: 'guest-list/tags-icons/maybes-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/maybes.svg',
    },
    {
      alt: 'Dog Owners',
      src: 'guest-list/tags-icons/dogowners-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/dogowners.svg',
    },
    {
      alt: 'Abc Lists',
      src: 'guest-list/tags-icons/alist-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/alist.svg',
    },
    {
      alt: 'Allergies',
      src: 'guest-list/tags-icons/allergies-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/allergies.svg',
    },
    {
      alt: 'Vegans',
      src: 'guest-list/tags-icons/vegans-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/vegans.svg',
    },
    {
      alt: 'Mom’s Friends',
      src: 'guest-list/tags-icons/momsfriends-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/momsfriends.svg',
    },
    {
      alt: 'Dog Owners',
      src: 'guest-list/tags-icons/dogowners-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/dogowners.svg',
    },
    {
      alt: 'Abc Lists',
      src: 'guest-list/tags-icons/alist-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/alist.svg',
    },
    {
      alt: 'Out of Towners',
      src: 'guest-list/tags-icons/outoftowners-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/outoftowners.svg',
    },
    {
      alt: 'Besties',
      src: 'guest-list/tags-icons/besties-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/besties.svg',
    },
    {
      alt: 'Designated Drivers',
      src: 'guest-list/tags-icons/designateddrivers-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/designateddrivers.svg',
    },
    {
      alt: 'Out of Towners',
      src: 'guest-list/tags-icons/outoftowners-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/outoftowners.svg',
    },
    {
      alt: 'Table Numbers',
      src: 'guest-list/tags-icons/tablenumbers-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/tablenumbers.svg',
    },
    {
      alt: 'Allergies',
      src: 'guest-list/tags-icons/allergies-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/allergies.svg',
    },
    {
      alt: 'Vegans',
      src: 'guest-list/tags-icons/vegans-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/vegans.svg',
    },
    {
      alt: 'Designated Drivers',
      src: 'guest-list/tags-icons/designateddrivers-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/designateddrivers.svg',
    },
    {
      alt: 'Kids',
      src: 'guest-list/tags-icons/kids-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/kids.svg',
    },
    {
      alt: 'Singles',
      src: 'guest-list/tags-icons/singles-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/singles.svg',
    },
    {
      alt: 'Abc Lists',
      src: 'guest-list/tags-icons/alist-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/alist.svg',
    },
    {
      alt: 'Dog Owners',
      src: 'guest-list/tags-icons/dogowners-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/dogowners.svg',
    },
    {
      alt: 'Gift tracking',
      src: 'guest-list/tags-icons/gifttracking-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/gifttracking.svg',
    },
    {
      alt: 'Out of Towners',
      src: 'guest-list/tags-icons/outoftowners-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/outoftowners.svg',
    },
    {
      alt: 'Table Numbers',
      src: 'guest-list/tags-icons/tablenumbers-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/tablenumbers.svg',
    },
    {
      alt: 'Besties',
      src: 'guest-list/tags-icons/besties-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/besties.svg',
    },
    {
      alt: 'Vegans',
      src: 'guest-list/tags-icons/vegans-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/vegans.svg',
    },
    {
      alt: 'Kids',
      src: 'guest-list/tags-icons/kids-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/kids.svg',
    },
    {
      alt: 'Maybes',
      src: 'guest-list/tags-icons/maybes-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/maybes.svg',
    },
    {
      alt: 'College Friends',
      src: 'guest-list/tags-icons/collegefriends-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/collegefriends.svg',
    },
    {
      alt: 'Gift tracking',
      src: 'guest-list/tags-icons/gifttracking-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/gifttracking.svg',
    },
    {
      alt: 'Designated Drivers',
      src: 'guest-list/tags-icons/designateddrivers-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/designateddrivers.svg',
    },
    {
      alt: 'Maybes',
      src: 'guest-list/tags-icons/maybes-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/maybes.svg',
    },
    {
      alt: 'Abc Lists',
      src: 'guest-list/tags-icons/alist-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/alist.svg',
    },
    {
      alt: 'Dog Owners',
      src: 'guest-list/tags-icons/dogowners-v2.svg',
      srcMobile: 'guest-list/tags-icons/mobile/dogowners.svg',
    },
  ],
} as const;
